import { render, staticRenderFns } from "./BillingDeletedList.vue?vue&type=template&id=18a8e737&scoped=true"
import script from "./BillingDeletedList.vue?vue&type=script&lang=js"
export * from "./BillingDeletedList.vue?vue&type=script&lang=js"
import style0 from "./BillingDeletedList.vue?vue&type=style&index=0&id=18a8e737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a8e737",
  null
  
)

export default component.exports